<template>
  <div
    class="flex flex-col py-2"
    :class="{ 'border-y border-g0': border, 'mb-2 bg-g0 p-2': !border }"
  >
    <div class="flex items-center justify-between">
      <div class="text-warning text-sm font-bold ml-2 mb-1">
        {{ $e('État du système de coupure') }} :
      </div>
      <router-link v-if="link"
        :to="{
          name: 'Site_DeviceEdit',
          hash: '#parachute',
          params: {
            sit_id: config?.deviceFamilly?.sit_id,
            dev_id: config?.deviceFamilly?.this_dev_id
          },
        }"
        class="
          cursor-pointer flex items-center justify-center
          px-3 py-[1px] rounded-lg !h-fit bg-flyingeye
          hover:bg-flyingeye-light mr-2
        "
      >
        <svg class="fill-current mr-1 h-full w-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 399.8 410.05">
          <path
            d="M199.9,150.35h0c-30.2,0-54.67,24.48-54.67,54.67s24.48,54.67,54.67,54.67,54.67-24.48,54.67-54.67-24.48-54.67-54.67-54.67Z" />
          <path
            d="M392.98,253.19s-.06-.03-.08-.05l-44.42-25.7c2.35-14.99,2.35-30.25,0-45.24l44.42-25.7c6.56-3.74,8.84-12.09,5.1-18.64-.02-.03-.03-.06-.05-.08l-41.01-71.07c-3.74-6.56-12.09-8.84-18.64-5.1-.03.01-.05.03-.08.05l-44.56,26.11c-11.79-9.56-24.97-17.26-39.09-22.83V13.67c0-7.55-6.12-13.67-13.67-13.67h-82.01c-7.55,0-13.67,6.12-13.67,13.67v51.26c-14.12,5.57-27.31,13.26-39.09,22.83l-44.56-25.7c-6.53-3.78-14.89-1.56-18.68,4.97-.02.03-.03.06-.05.08L1.84,138.19c-3.78,6.53-1.56,14.89,4.97,18.68.03.02.06.03.08.05l44.43,25.7c-2.35,14.99-2.35,30.25,0,45.24l-44.43,25.56c-6.51,3.75-8.77,12.05-5.06,18.59l41,71.08c3.74,6.56,12.09,8.84,18.64,5.1.03-.02.06-.03.08-.05l44.56-25.7c11.79,9.52,24.98,17.17,39.09,22.69v51.26c0,7.55,6.12,13.67,13.67,13.67h82.01c7.55,0,13.67-6.12,13.67-13.67v-51.25c14.12-5.56,27.31-13.26,39.09-22.83l44.56,25.7c6.53,3.78,14.89,1.56,18.68-4.97.02-.03.03-.06.05-.08l41-71.08c3.78-6.53,1.56-14.89-4.97-18.68ZM199.9,287.04c-45.29,0-82.01-36.72-82.01-82.01h0c0-45.29,36.72-82.01,82.01-82.01s82.01,36.72,82.01,82.01-36.72,82.01-82.01,82.01Z" />
        </svg>
        {{ $e('Réglage') }}
      </router-link>
    </div>
    <div class="flex px-2">
      <span class="text-g3">
        {{ $e("État FTS") }} : 
      </span>
      <Parachute_FTS :config="config" />
    </div>
  </div>

  <div class="flex py-2 flex-col" :class="{ 'border-y border-g0': border, 'mb-2 bg-g0 p-2': !border }">
    <div class="text-warning text-sm font-bold ml-2 mb-1">
      {{ $e('Charge pytotechnique') }} :
    </div>
    <div class="flex justify-between px-2">
      <Parachute_Pyro :config="config" />
    </div>
  </div>

  <div class="flex py-2 flex-col" :class="{ 'border-y border-g0': border, 'mb-2 bg-g0 p-2': !border }">
    <div class="text-warning text-sm font-bold ml-2 mb-1">
      {{ $e('Fence') }} :
    </div>
    <div class="flex justify-between px-2 flex-col">
      <Parachute_Fence_Enable :config="config" />
      <Parachute_Fence_Status :config="config" />
    </div>
  </div>
</template>

<script>
import Parachute_FTS from "@/partials/Device/Template/Parachute/Parachute_FTS.vue";
import Parachute_Fence_Enable from "@/partials/Device/Template/Parachute/Parachute_Fence_Enable.vue";
import Parachute_Fence_Status from "@/partials/Device/Template/Parachute/Parachute_Fence_Status.vue";
import Parachute_Pyro from "@/partials/Device/Template/Parachute/Parachute_Pyro.vue";

export default {
  name: "Parachute_Template",
  components: {
    Parachute_FTS,
    Parachute_Fence_Enable,
    Parachute_Fence_Status,
    Parachute_Pyro,
  },
  props: {
    config: Object,
    link: Boolean,
    border: Boolean,
  },
  setup() {
    return {
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
